<template>
	<SOSlotModal
		:modal-title="'Duplikasi Nama Konsumen'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="f-regular f-16 f-c-black m-d-12">
				Ditemukan beberapa <b>nama konsumen</b> yg sama dengan data yg sudah ada :
			</div>
			<div class="f-regular f-16 f-c-black"
			     v-for="customer in listDuplicate.slice(0, 5)"
			>
				- {{ customer }}
			</div>
			<div class="f-regular f-14 f-c-midgrey m-d-12" v-if="listDuplicate.length > 5">
				Serta {{ listDuplicate.length - 5 }} konsumen lainnya...
			</div>
			<div class="f-regular f-16 f-c-black m-d-16">
				Yakin tetap ingin mengimpor data konsumen?
			</div>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:primary="true"
				:full="true"
				:text="'Tetap Import'"
				:disable="pageSetting.btn.next.disabled"
				:loading="pageSetting.btn.next.loading"
				@action="forceImport"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "CustomerModalNamaDuplikat",
	components: {
		SOSlotModal,
		SOButton
	},
	props: {
		listDuplicate: Array,
	},
	data() {
		return {
			id: "modal-duplicated-name",
			pageSetting: {
				btn: {
					next: {
						disabled: false,
						loading: false,
					}
				}
			}
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		forceImport() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("force-import")
			}, 500)
		}
	}
}
</script>